import defaultThumbnail from "@assets/ChatGPT_Image_Mar_3,_2026,_12_49_24_AM_1772517025333.png";
import recordingThumbnail from "@assets/ChatGPT_Image_Mar_3,_2026,_12_49_24_AM_1772517025333.png";

export const DEFAULT_THUMBNAIL = defaultThumbnail;
export const RECORDING_THUMBNAIL = recordingThumbnail;
